// extracted by css-extract-rspack-plugin
export default {"infoIcon":"vxdA9"};